module.exports = __webpack_public_path__ + "img/tr.280314a7.png";